// src/Home.js
import { useEffect, useState, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../tasks/task.css";
import "./style.css";
import {
  addFileMessage,
  delMessage,
  editMessage,
  getAllMessages,
  getMessages,
  getMessagesViewMeta,
  getMessages20,
  markCompanyChatRead,
  markClientMessagesRead,
  sendMessage,
  sendMessageFile,
  sendMessageHttp,
  sendMessageTest,
  sendMessageWA,
} from "./chatApi";
import { useSocket } from "./useSocket";
import { selectStartIndex, selectUserName, setStartIndex } from "./chatSlice";
import {
  selectUserId,
  selectName,
  selectAccId,
  selectUsers,
  selectCurrentUser,
} from "../login/loginSlice";
import { getUserData } from "../login/loginApi";
import { useNavigate, useLocation } from "react-router-dom";
// import { url } from './constants';

import React from "react";

// const url = process.env.REACT_APP_API_URL;
import { url, SOCKET_URL } from "../../static/env";
import { connectionFailedMessage } from "../../utils/fetchWithRetry";
import CompanyPickerList from "../shared/CompanyPickerList";
import { useSectionCompanyPicker } from "../../hooks/useSectionCompanyPicker";
import { applyMarkCompanyChatUnread } from "../../utils/markCompanyChatUnreadClient";
import { useSectionMenuReset } from "../../context/SectionMenuResetContext";
import { usePickerBadgeMap, useAccountBadgesContext } from "../../context/AccountBadgesContext";
import { formatBadgeCount } from "../../utils/badgeCounts";
import "../shared/companyPicker.css";
import SuspendHoverHint from "../shared/SuspendHoverHint";
import { useBuhServiceSuspended } from "../../hooks/useBuhServiceSuspended";
import { buildAttachmentPreview } from "./chatAttachmentPreview";
import {
  createBusinessCompanyChat,
  getBusinessCompanyChats,
  getEmployeeAccessibleChats,
} from "../login/loginApi";
import {
  fileSelect,
  sendIcon,
  singleCheck,
  doubleCheck,
  arrowLIcon,
  arrowRIcon,
  closeIconTask,
} from "../../static/svgs";
import file_img from "../../static/img/file.png";

const COMPANY_CHATS_STORAGE_KEY = "companyChatsByUserId";

function loadCompanyChatsMap() {
  try {
    const raw = localStorage.getItem(COMPANY_CHATS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function saveCompanyChatsMap(map) {
  localStorage.setItem(COMPANY_CHATS_STORAGE_KEY, JSON.stringify(map));
}

function getDefaultCompanyChats() {
  return [{ id: "default", title: "Основной", isDefault: true }];
}

function getCompanyChats(companyUserId) {
  const key = String(companyUserId || "");
  if (!key) return getDefaultCompanyChats();
  const map = loadCompanyChatsMap();
  const list = map[key];
  if (Array.isArray(list) && list.length > 0) return list;
  return getDefaultCompanyChats();
}

function persistCompanyChats(companyUserId, chats) {
  const key = String(companyUserId || "");
  if (!key) return;
  const map = loadCompanyChatsMap();
  map[key] = chats;
  saveCompanyChatsMap(map);
}

function mapApiChats(chats) {
  return (chats || []).map((c) => ({
    id: c.id,
    title: c.title,
    isDefault: !!c.is_default,
    unread: Number(c.unread_messages) || 0,
  }));
}

async function fetchChatsForCompanyUser({ user, businessAccountId, sessionUserId }) {
  if (user.access_mode === "delegated") {
    const employeeUserId = user.employee_user_id || businessAccountId;
    const result = await getEmployeeAccessibleChats(employeeUserId, {
      companyId: user.company_id,
      legacyUserId: user.legacy_user_id || undefined,
    });
    return result.success ? mapApiChats(result.chats) : [];
  }
  const companyLegacyId = Number(user.legacy_user_id) || 0;
  const companyBizId =
    Number(user.company_owner_user_id) || Number(user.business_user_id) || 0;
  const bizId =
    Number(businessAccountId) ||
    Number(sessionUserId) ||
    (companyBizId && companyBizId !== companyLegacyId ? companyBizId : 0) ||
    companyBizId;
  if (!user.company_id || !bizId) {
    return getCompanyChats(user.user_id);
  }
  const result = await getBusinessCompanyChats(bizId, user.company_id);
  return result.success ? mapApiChats(result.chats) : [];
}

let current_chat = 1;
let state_alarm = false;
let alarmInterval;
let all_messages;
let chat_messages = {};
let chats_;

var tick = -1;
let start_ind = 0;

function Chat() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { socket } = useSocket();
  const location = useLocation();

  const name = useSelector(selectName);
  const userId = useSelector(selectUserId);
  const acc_id = useSelector(selectAccId);
  const users = useSelector(selectUsers);
  const currentUser = useSelector(selectCurrentUser);
  const start_index = useSelector(selectStartIndex);
  const {
    multiple,
    pickerOpen,
    setPickerOpen,
    selectAccount,
    pickerUsers,
    loading: accessLoading,
    loadError: accessLoadError,
    noAccess,
    isEmployee,
    businessAccountId,
  } = useSectionCompanyPicker("chat");
  const pickerBadgeByUserId = usePickerBadgeMap("chat", pickerUsers);
  const isServiceSuspended = useBuhServiceSuspended(
    userId,
    Number(currentUser?.company_id) || 0
  );

  /** Собеседник в API сообщений: сессия (userId), не stale business_user_id из userList. */
  const messagePeerUserId = useMemo(() => {
    if (isEmployee && currentUser?.legacy_user_id) {
      return Number(currentUser.legacy_user_id);
    }
    const sessionId = Number(userId) || 0;
    if (!isEmployee && sessionId) return sessionId;
    const biz =
      Number(businessAccountId) ||
      Number(currentUser?.business_user_id) ||
      0;
    if (biz > 0) return biz;
    const legacy = Number(currentUser?.legacy_user_id);
    if (legacy > 0) return legacy;
    if (currentUser?.is_company_context || currentUser?.is_company_record) {
      return null;
    }
    return sessionId || null;
  }, [isEmployee, currentUser, businessAccountId, userId]);

  const [chatListOpen, setChatListOpen] = useState(true);
  const [chatsByUserId, setChatsByUserId] = useState({});
  const [activeCompanyChat, setActiveCompanyChat] = useState(null);
  const [showCreateChatModal, setShowCreateChatModal] = useState(false);
  const [newChatTitle, setNewChatTitle] = useState("");
  const [createChatBusy, setCreateChatBusy] = useState(false);
  const [createChatTargetUser, setCreateChatTargetUser] = useState(null);
  const pendingOpenChatRef = useRef(null);

  /** Фото/имя из профиля владельца аккаунта (куда заведены компании). */
  const [accountOwnerProfile, setAccountOwnerProfile] = useState({
    photo_path: null,
    name: null,
  });

  useEffect(() => {
    const bizId = Number(businessAccountId) || 0;
    if (!bizId) {
      setAccountOwnerProfile({ photo_path: null, name: null });
      return undefined;
    }
    let cancelled = false;
    getUserData(bizId)
      .then((data) => {
        if (cancelled) return;
        const row = data?.user?.[0];
        setAccountOwnerProfile({
          photo_path: row?.photo_path || null,
          name: row?.name || null,
        });
      })
      .catch(() => {
        if (!cancelled) {
          setAccountOwnerProfile({ photo_path: null, name: null });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [businessAccountId]);

  const accountOwnerAvatar = useMemo(() => {
    const bizId = Number(businessAccountId) || 0;
    const companyId =
      Number(currentUser?.company_id) ||
      Number(activeCompanyChat?.company_id) ||
      0;
    const fromPicker = companyId
      ? pickerUsers.find((u) => Number(u.company_id) === companyId)
      : null;
    const loginRow = (users || []).find(
      (u) =>
        u &&
        !u.is_company_context &&
        !u.is_company_record &&
        (!bizId || Number(u.user_id) === bizId)
    );
    // Приоритет: профиль владельца аккаунта (getUserData), затем мета пикера/логина
    const photoPath =
      accountOwnerProfile.photo_path ||
      currentUser?.owner_photo_path ||
      fromPicker?.owner_photo_path ||
      loginRow?.photo_path ||
      (currentUser &&
      !currentUser.is_company_context &&
      !currentUser.is_company_record
        ? currentUser.photo_path
        : null) ||
      null;
    const displayName =
      accountOwnerProfile.name ||
      currentUser?.owner_name ||
      fromPicker?.owner_name ||
      loginRow?.company_name ||
      (currentUser &&
      !currentUser.is_company_context &&
      !currentUser.is_company_record
        ? currentUser.name
        : null) ||
      null;
    const path = photoPath ? String(photoPath).replace(/^\/+/, "") : "";
    return {
      uri: path ? `${url}/${path}` : null,
      name: displayName,
      initial: displayName
        ? String(displayName).trim().charAt(0).toUpperCase() || "А"
        : "А",
    };
  }, [
    accountOwnerProfile,
    businessAccountId,
    currentUser,
    users,
    pickerUsers,
    activeCompanyChat?.company_id,
  ]);

  useSectionMenuReset("/chat", () => {
    if (!pickerOpen) {
      setActiveCompanyChat(null);
      setChatListOpen(true);
      setPickerOpen(true);
      return true;
    }
    return false;
  });

  const { refresh: refreshAccountBadges, patchChatBadge, chatByChatId } = useAccountBadgesContext();

  const [chats, setChats] = useState([]);
  const [pickerContextMenu, setPickerContextMenu] = useState(null);
  const [message, setMessage] = useState("");
  const [uploadFiles, setUploadFiles] = useState([]);
  const [uploadPreviews, setUploadPreviews] = useState([]);
  const [fileActionModal, setFileActionModal] = useState(null);
  const [currentChatId, setCurrentChatId] = useState(1);
  const [chatMessages, setChatMessages] = useState([]);
  const [newMessageChatId, setNewMessageChatId] = useState(0);
  const [findText, setFindText] = useState("");
  const [findChatText, setFindChatText] = useState("");
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchMatchIndices, setSearchMatchIndices] = useState([]);
  const [activeSearchMatchIdx, setActiveSearchMatchIdx] = useState(0);
  const [serverOn, setServerOn] = useState(true);
  const [qoutedMessageIndex, setQoutedMessageIndex] = useState(0);
  const [findChatsMsg, setfindChatsMsg] = useState([]);
  const [startIndexMsg, setStartIndexMsg] = useState(0);
  const [endIndexMsg, setEndIndexMsg] = useState(20);
  /** Пока грузим историю с сервера — показываем «Загрузка», без фиктивных сообщений */
  const [messagesLoading, setMessagesLoading] = useState(true);
  const [connectionStatus, setConnectionStatus] = useState("");
  const [contextMenu, setContextMenu] = useState(null);
  const [editModal, setEditModal] = useState(null);

  /** Прокрутка вниз только после полной подгрузке истории (открытие чата / смена диалога), не при каждом новом сообщении */
  const scrollToBottomAfterLoadRef = useRef(false);
  const chatMessagesRef = useRef([]);
  const chatLoadGenRef = useRef(0);
  const activeCompanyChatRef = useRef(null);

  useEffect(() => {
    chatMessagesRef.current = chatMessages;
  }, [chatMessages]);

  function applyViewMetaRows(messages, rows) {
    if (!rows || !rows.length) return messages;
    const byId = new Map(rows.map((r) => [Number(r.id), r]));
    return messages.map((m) => {
      const row = byId.get(Number(m.id));
      if (!row) return m;
      return {
        ...m,
        is_viewed: row.is_viewed,
        view_status: row.view_status,
        is_viewed_user: row.is_viewed_user,
        view_status_user: row.view_status_user,
      };
    });
  }

  /** Быстрый список + view-meta; полный /messages в фоне — синхронизация прочитанности в БД (ветка без messages_fast). */
  async function loadChatMessages(forUserId, chatId = null) {
    const gen = ++chatLoadGenRef.current;
    const resolvedChatId = Number(chatId) || null;
    const peerId = Number(forUserId) || Number(messagePeerUserId) || 0;
    if (!peerId) {
      console.warn('[chat] loadChatMessages: no peerId', { forUserId, messagePeerUserId });
      setMessagesLoading(false);
      return;
    }
    const markReadUserId = Number(businessAccountId) || peerId;
    console.log('[chat] mark-read', {
      peerId,
      markReadUserId,
      businessAccountId,
      chatId: resolvedChatId,
    });
    markCompanyChatRead(markReadUserId)
      .catch((e) => console.warn("markCompanyChatRead:", e));
    if (resolvedChatId) {
      setChatsByUserId((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((key) => {
          next[key] = (next[key] || []).map((c) =>
            Number(c.id) === resolvedChatId ? { ...c, unread: 0 } : c
          );
        });
        return next;
      });
    }
    const badgeUserId = markReadUserId;
    patchChatBadge(badgeUserId, undefined, {
      chatId: resolvedChatId || 0,
    });
    markClientMessagesRead(markReadUserId, { chat_id: resolvedChatId || undefined })
      .then((data) => {
        const unreadLeft = Number(data?.unread_count) || 0;
        const manualLeft = Number(data?.manual_unread) || 0;
        const badge = unreadLeft > 0 ? unreadLeft : (manualLeft ? 1 : 0);
        patchChatBadge(badgeUserId, badge, {
          chatId: resolvedChatId || 0,
          companyId: Number(currentUser?.company_id) || 0,
          byChatId: data?.by_chat_id,
          byCompanyId: data?.by_company_id,
        });
      })
      .catch((e) => console.warn("markClientMessagesRead:", e))
      .finally(() => {
        refreshAccountBadges();
      });
    setMessagesLoading(true);
    setConnectionStatus("");
    let list = [];
    try {
      const fast = await getMessages(markReadUserId, {
        messages_fast: true,
        chat_id: resolvedChatId || undefined,
        onRetryProgress: ({ message, status }) => {
          if (gen !== chatLoadGenRef.current) return;
          if (message && status !== "completed") {
            setConnectionStatus(message);
          }
        },
      });
      if (gen !== chatLoadGenRef.current) return;
      list = Array.isArray(fast) ? fast : [];
      scrollToBottomAfterLoadRef.current = true;
      setChatMessages(list);
      setConnectionStatus("");
    } catch (e) {
      if (gen === chatLoadGenRef.current) {
        setConnectionStatus(e.userMessage || connectionFailedMessage());
      }
    } finally {
      if (gen === chatLoadGenRef.current) {
        setMessagesLoading(false);
      }
    }

    if (gen !== chatLoadGenRef.current) return;

    const ids = list.map((m) => m.id).filter((id) => id != null);
    if (ids.length) {
      getMessagesViewMeta(markReadUserId, ids, 0)
        .then((rows) => {
          if (gen !== chatLoadGenRef.current || !rows?.length) return;
          setChatMessages((prev) => applyViewMetaRows(prev, rows));
        })
        .catch((e) => console.warn("getMessagesViewMeta:", e));
    }

    getMessages(markReadUserId, { chat_id: resolvedChatId || undefined })
      .then(() => {
        refreshAccountBadges();
      })
      .catch(() => {});
  }

  let end_ind = 20;
  let stop_scroll = false;

  function setOldScroll(diff) {
    var objDiv = document.getElementById("messages");

    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight - diff;
    }
  }

  function scrollToBottom() {
    clearInterval(alarmInterval);
    alarmInterval = 0;
    setDefaultIcon();

    var objDiv = document.getElementById("messages");
    if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
  }

  function goUpChat(chat_id) {
    let arr_cht = chats.slice();
    const ind = arr_cht.findIndex((e) => e.id === chat_id);
    let el_up = arr_cht[ind];
    for (let i = ind; i > 0; i--) {
      arr_cht[i] = arr_cht[i - 1];
    }
    arr_cht[0] = el_up;
    setChats(arr_cht);
    chats_ = arr_cht;
  }

  function goUpChatS(chat_id) {
    // let arr_cht = chats_.slice();
    // const ind = arr_cht.findIndex(e => e.id === chat_id);
    // let el_up = arr_cht[ind];
    // for (let i = ind; i > 0; i--) {
    //     arr_cht[i] = arr_cht[i - 1];
    // }
    // arr_cht[0] = el_up;
    // setChats(arr_cht);
    // chats_ = arr_cht;
  }

  async function deliverTextMessage(text, quotedMsgId, serializedId) {
    if (isServiceSuspended) return;

    const chatId = Number(activeCompanyChat?.id) || null;
    // Руководитель: всегда сессия Redux (userId=131), не currentUser.business_user_id.
    // business_user_id часто = старый client (46) из userList — из‑за него бэк
    // проверяет приостановку не у той компании, которая открыта в UI.
    const legacyId = Number(currentUser?.legacy_user_id) || 0;
    const bizId = Number(currentUser?.business_user_id) || 0;
    const sessionId = Number(userId) || 0;
    const senderId = isEmployee
      ? Number(currentUser?.employee_user_id || userId)
      : sessionId;
    const toAccountantId =
      Number(currentUser?.accountant_id || acc_id) || null;
    const payload = {
      text,
      from_id: senderId,
      to_id: toAccountantId,
      reply_id: quotedMsgId || 0,
      is_buh: false,
    };
    if (chatId) payload.chat_id = chatId;
    const diag = {
      socketUrl: SOCKET_URL,
      apiUrl: url,
      socketConnected: !!socket?.connected,
      socketId: socket?.id,
      userId,
      senderId,
      bizId,
      legacyId,
      isEmployee,
      acc_id: toAccountantId,
      textLen: text.length,
    };
    console.log("[chat/sendMessage] attempt", diag, payload);

    if (!toAccountantId) {
      console.error("[chat/sendMessage] abort: accountant_id (acc_id) is empty");
      alert("Не назначен бухгалтер. Невозможно отправить сообщение.");
      return;
    }

    const optimistic = {
      id: `local-${Date.now()}`,
      from_id: senderId,
      to_id: toAccountantId,
      text,
      datetime: new Date().toISOString(),
      reply_id: quotedMsgId || 0,
      chat_id: chatId,
      client_id: senderId,
      sender_type: isEmployee ? "сотрудник" : "клиент",
    };
    setChatMessages((prev) => [...prev, optimistic]);

    if (socket?.connected) {
      socket.emit("sendMessage", payload);
      console.log("[chat/sendMessage] emitted via socket");
      return;
    }

    console.warn("[chat/sendMessage] socket offline, trying HTTP /sendmessage");
    try {
      await sendMessageHttp(payload);
      console.log("[chat/sendMessage] HTTP ok");
    } catch (e) {
      console.error("[chat/sendMessage] HTTP failed", e);
      alert("Не удалось отправить сообщение. Проверьте соединение.");
      throw e;
    }
  }

  function handleClickSendMessage() {
    if (isServiceSuspended) return;

    if (uploadFiles.length > 0) {
      console.log("uploadFile", uploadFiles);
      // goUpChat(currentChatId);
      // sendMessageFile({ upload_file: uploadFile, chat_id: currentChatId, user_id: userId }, (data) => {
      //     setUploadFile(false);
      //     let file = document.getElementById("myfile");
      //     if (file) file.value = '';
      //     console.log('handleClickSendMessage')
      //     getMessages({ chat_id: currentChatId, user_id: userId }, (data) => {
      //         setIndexes(data.messages, tick);
      //         setChatMessages(data.messages);
      //         setTimeout(() => {
      //             var objDiv = document.getElementById("messages");
      //             if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
      //         }, 1000);
      //     });
      // });

      addFileMessage(
        {
          files: uploadFiles,
          // type: uploadFiles[0].mimeType,
          userId: isEmployee
            ? Number(currentUser?.employee_user_id || userId)
            : userId,
          toId: Number(currentUser?.accountant_id || acc_id) || null,
          text: message,
          chatId: Number(activeCompanyChat?.id) || null,
        },
        (data) => {
          setUploadFiles([]);
          console.log("data file", data);
          // const fetchData = async () => {
          //     const messages_res = await getMessages(userId);
          //     setChatMessages(messages_res);
          // };

          // fetchData();
        }
      );
    } else if (message.trim() === "") {
      return;
    } else {
      console.log("handleClickSendMessage");
      const textToSend = message.trim();
      let inp = document.getElementById("inputmessage");
      if (inp) inp.style.height = "5vh";

      const quoted_msg_id =
        qoutedMessageIndex === 0
          ? ""
          : chatMessages[qoutedMessageIndex].message_id;
      const serialized_id =
        qoutedMessageIndex === 0
          ? ""
          : chatMessages[qoutedMessageIndex].serialized_id;

      setMessage("");
      deliverTextMessage(textToSend, quoted_msg_id, serialized_id).catch(
        () => {}
      );
      return;
    }
    setMessage("");
  }

  function setDefaultIcon() {
    const favicon = document.getElementById("icon");
    if (favicon) favicon.setAttribute("href", "favicon.ico");
  }

  function alarmNewMsg() {
    const favicon = document.getElementById("icon");
    if (state_alarm) {
      if (favicon) favicon.setAttribute("href", "newmsg.ico");
    } else {
      if (favicon) favicon.setAttribute("href", "favicon.ico");
    }
    state_alarm = !state_alarm;
  }

  useEffect(() => {
    activeCompanyChatRef.current = activeCompanyChat;
  }, [activeCompanyChat]);

  const handleSocketRef = useRef(null);

  const handleSocket = (arg) => {
    const peerId = Number(messagePeerUserId) || Number(businessAccountId) || Number(userId) || 0;
    console.log("handleSocket", arg, { userId, peerId, businessAccountId });

    const openChatId = Number(activeCompanyChatRef.current?.id) || 0;
    const msgChatId = Number(arg.chat_id) || 0;
    const toId = Number(arg.to_id) || 0;
    const fromId = Number(arg.from_id) || 0;
    const clientId = Number(arg.client_id) || 0;
    const myIds = new Set(
      [
        userId,
        peerId,
        businessAccountId,
        currentUser?.business_user_id,
        currentUser?.legacy_user_id,
        currentUser?.employee_user_id,
      ]
        .map((v) => Number(v) || 0)
        .filter((v) => v > 0)
    );
    const forMe =
      myIds.has(fromId) ||
      myIds.has(toId) ||
      myIds.has(clientId);
    // Сотрудник: from/to — business/accountant, не employee user_id → смотрим chat_id
    const forOpenCompanyChat =
      openChatId > 0 && msgChatId > 0 && openChatId === msgChatId;

    if (forMe || forOpenCompanyChat) {
      if (openChatId && msgChatId && openChatId !== msgChatId) {
        return;
      }
      console.log("setChatMessages");
      setChatMessages((prevMessages) => {
        const incomingId = Number(arg.id);
        if (incomingId && prevMessages.some((m) => Number(m.id) === incomingId)) {
          return prevMessages;
        }
        const withoutLocal = prevMessages.filter((m) => {
          const id = m?.id;
          if (id == null || !String(id).startsWith("local-")) return true;
          return !(
            String(m.text || "") === String(arg.text || "") &&
            Number(m.from_id) === fromId
          );
        });
        return [...withoutLocal, arg];
      });

      // Отправляем фидбэк на бэк, подобно десктоп-клиенту
      try {
        const messageId = arg.id || arg.message_id || null;
        const isChatRoute =
          location &&
          location.pathname &&
          location.pathname.startsWith("/chat");
        // «viewed» только когда реально открыта лента чата, не пикер компаний/список чатов
        const chatThreadOpen = !!isChatRoute && !pickerOpen && !chatListOpen && openChatId > 0;
        console.log(
          "isChatRoute:",
          isChatRoute,
          "chatThreadOpen:",
          chatThreadOpen,
          "pickerOpen:",
          pickerOpen,
          "chatListOpen:",
          chatListOpen
        );
        const status = chatThreadOpen ? "viewed" : "received";
        const payload = {
          message_id: messageId,
          user_id: peerId || userId,
          status: status,
          buh_id: null,
        };
        console.log("Emitting feedbackMessage", payload);
        socket.emit("feedbackMessage", payload);
        if (!chatThreadOpen && peerId) {
          refreshAccountBadges();
        }
      } catch (err) {
        console.error("Error emitting feedbackMessage", err);
      }
    }

    const favicon = document.getElementById("icon");
    if (favicon) {
      favicon.setAttribute("href", "newmsg.ico");
    }
    clearInterval(alarmInterval);
    alarmInterval = 0;
    if (alarmInterval === 0) {
      const interval = setInterval(() => alarmNewMsg(), 1000);
      alarmInterval = interval;
    }
  };

  handleSocketRef.current = handleSocket;

  function handleDoubleClick(index) {
    setQoutedMessageIndex(index);
  }

  function formatMessageSentLine(iso, editedAt) {
    if (editedAt) {
      const d = new Date(editedAt);
      if (!Number.isNaN(d.getTime())) {
        return `Изменено: ${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
      }
    }
    if (!iso) return "Отправлено";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "Отправлено";
    return `Отправлено ${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
  }

  function setIndexes(messages, tick) {
    console.log("setIndexes", messages.length);
    if (messages.length >= 20) {
      setStartIndexMsg(messages.length - 21);
      setEndIndexMsg(messages.length - 1);
    }
  }

  function createHandleScroll(chat_id, tick, stop_scroll) {
    return function handleScroll() {
      if (stop_scroll) return;
      else {
        // console.log('handleScroll', tick, stop_scroll);
        stop_scroll = true;
      }
      var objDiv = document.getElementById("messages");

      if (objDiv) {
        if (objDiv.scrollTop > objDiv.scrollHeight - 600 && !stop_scroll) {
          stop_scroll = true;
          clearInterval(alarmInterval);
          alarmInterval = 0;
          setDefaultIcon();

          setTimeout(() => (stop_scroll = false), 500);
        } else if (objDiv.scrollTop < 10 && chat_id) {
          setTimeout(() => (stop_scroll = false), 500);
          let diff_h = objDiv.scrollHeight - objDiv.scrollTop;
          stop_scroll = true;
          if (tick > 20) {
            setStartIndexMsg(tick - 20);
            tick = tick - 20;
            setTimeout(() => setOldScroll(diff_h), 100);
            console.log("> 20", tick, diff_h);
          } else if (tick === -1 && chat_messages[chat_id]) {
            // setChatMessages(chat_messages[chat_id]);
            setStartIndexMsg(chat_messages[chat_id].length - 21);
            setEndIndexMsg(chat_messages[chat_id].length - 1);
            tick = chat_messages[chat_id].length - 21;
            console.log("0-20");
          } else {
            console.log("0");
            start_ind = 0;
            setStartIndexMsg(0);
          }
        } else setTimeout(() => (stop_scroll = false), 50);
      }
    };
  }

  let handleScroll;

  let timer = 0;

  function setHandleScroll(chat_id, tick) {
    // console.log('setHandleScroll', chat_id);
    const objDiv = document.getElementById("messages");

    if (objDiv) objDiv.removeEventListener("scroll", handleScroll);
    handleScroll = createHandleScroll(chat_id, tick, stop_scroll);
    if (objDiv) objDiv.addEventListener("scroll", handleScroll);
  }

  function cleanFileName(fileName) {
    const dotIndex = fileName.lastIndexOf(".");
    const ext = fileName.slice(dotIndex);
    let base = fileName.slice(0, dotIndex);
    if (base.includes("-")) {
      base = base.split("-").slice(0, -1).join("-"); // убираем последний дефис и таймштамп
    }
    return base + ext;
  }

  // Форматируем размер файла
  function formatSize(size) {
    if (!size) return "";
    if (size < 1024) return `${size} B`;
    if (size < 1024 ** 2) return `${(size / 1024).toFixed(1)} KB`;
    if (size < 1024 ** 3) return `${(size / 1024 ** 2).toFixed(1)} MB`;
    return `${(size / 1024 ** 3).toFixed(1)} GB`;
  }

  useEffect(() => {
    if (!userId || userId === 0) {
      navigate("/");
      return;
    }

    const pending = pendingOpenChatRef.current;
    pendingOpenChatRef.current = null;
    if (pending) {
      setActiveCompanyChat(pending);
      setChatListOpen(false);
    }
  }, [userId, navigate, isEmployee]);

  const pickerUsersKey = pickerUsers
    .map((u) => `${u.user_id}:${u.company_id || ""}:${u.access_mode || ""}`)
    .join("|");

  useEffect(() => {
    if (!pickerOpen || accessLoading || noAccess || !pickerUsers.length) return;
    let cancelled = false;
    const usersToLoad = pickerUsers;

    (async () => {
      const entries = await Promise.all(
        usersToLoad.map(async (user) => {
          try {
            const chats = await fetchChatsForCompanyUser({
              user,
              businessAccountId,
              sessionUserId: userId,
            });
            return [String(user.user_id), chats];
          } catch (e) {
            console.error(e);
            return [String(user.user_id), []];
          }
        })
      );
      if (!cancelled) {
        setChatsByUserId(Object.fromEntries(entries));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    pickerOpen,
    accessLoading,
    noAccess,
    pickerUsersKey,
    pickerUsers,
    businessAccountId,
    userId,
  ]);

  useEffect(() => {
    if (!userId || userId === 0) return;
    if (chatListOpen || pickerOpen || noAccess || !activeCompanyChat) return;

    const chatId = Number(activeCompanyChat?.id) || null;
    // Раньше без legacy_user_id историю не грузили (фильтр был по client_id).
    // Теперь сообщения живут в chat_id — грузим, если есть id чата.
    if (
      isEmployee &&
      currentUser?.is_company_context &&
      !currentUser?.has_legacy_user &&
      !currentUser?.legacy_user_id &&
      !chatId
    ) {
      setChatMessages([]);
      setMessagesLoading(false);
      setConnectionStatus("");
      return;
    }

    const messageUserId = messagePeerUserId;
    loadChatMessages(messageUserId, chatId);
  }, [
    userId,
    messagePeerUserId,
    navigate,
    chatListOpen,
    pickerOpen,
    activeCompanyChat,
    noAccess,
    isEmployee,
    currentUser,
  ]);

  useEffect(() => {
    if (!scrollToBottomAfterLoadRef.current) return;
    scrollToBottomAfterLoadRef.current = false;
    const run = () => {
      const el = document.getElementById("messages");
      if (el) el.scrollTop = el.scrollHeight;
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        run();
        setTimeout(run, 80);
        setTimeout(run, 300);
      });
    });
  }, [chatMessages]);

  useEffect(() => {
    const onNewMessage = (arg) => handleSocketRef.current?.(arg);
    socket.on("newMessage", onNewMessage);
    socket.on("buhServiceSuspended", (data) => {
      console.warn("[chat] buhServiceSuspended", data);
      setChatMessages((prev) =>
        prev.filter((m) => !String(m?.id || "").startsWith("local-"))
      );
      alert(data?.error || "Обслуживание приостановлено. Сообщение не отправлено.");
    });
    socket.on("sendMessageError", (data) => {
      console.error("[chat] sendMessageError", data);
      setChatMessages((prev) =>
        prev.filter((m) => !String(m?.id || "").startsWith("local-"))
      );
      alert(data?.error || "Не удалось отправить сообщение.");
    });
    socket.on("delMessage", (data) => {
      const msgId = data?.message_id ?? data?.messageId;
      if (msgId) {
        setChatMessages((prev) => prev.filter((m) => m.id !== msgId));
      }
    });
    socket.on("editMessage", (data) => {
      const { message_id, text, edited_at } = data;
      if (message_id && text !== undefined) {
        setChatMessages((prev) =>
          prev.map((m) =>
            m.id === message_id
              ? { ...m, text, edited_at: edited_at || m.edited_at }
              : m
          )
        );
      }
    });

    return () => {
      socket.off("newMessage", onNewMessage);
      socket.removeAllListeners("buhServiceSuspended");
      socket.removeAllListeners("sendMessageError");
      socket.removeAllListeners("delMessage");
      socket.removeAllListeners("editMessage");
    };
  }, [socket]);

  useEffect(() => {
    socket.on("serveron", () => setServerOn(true));
    return () => {
      socket.removeAllListeners("serveron");
    };
  }, []);

  useEffect(() => {
    const handleViewMessages = (data) => {
      console.log("handleViewMessages", data, userId);
      // Всегда тянем актуальные статусы с сервера (без проверки по устаревшему chatMessages из замыкания).
      fetchMessageStatuses();
    };

    const fetchMessageStatuses = async () => {
      try {
        const ids = chatMessagesRef.current
          .map((m) => m.id)
          .filter((id) => id != null);
        if (!ids.length) return;
        const rows = await getMessagesViewMeta(userId, ids, 0);
        if (!rows?.length) return;
        setChatMessages((prev) => applyViewMetaRows(prev, rows));
      } catch (error) {
        console.error("Ошибка при обновлении статусов сообщений:", error);
      }
    };

    socket.on("viewMessages", handleViewMessages);
    return () => {
      socket.removeAllListeners("viewMessages");
    };
  }, [userId, socket]);

  const handleMessageContextMenu = (e, message) => {
    e.preventDefault();
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      message,
    });
  };

  const handleEditMessage = async (messageId, text) => {
    try {
      const result = await editMessage(messageId, text);
      if (result?.result) {
        setChatMessages((prev) =>
          prev.map((m) =>
            m.id === messageId
              ? { ...m, text, edited_at: result.edited_at || m.edited_at }
              : m
          )
        );
      }
    } catch (err) {
      console.error("Error editing message:", err);
    }
    setEditModal(null);
  };

  const handleDeleteMessage = async (messageId) => {
    try {
      const result = await delMessage(messageId);
      if (result?.result) {
        setChatMessages((prev) => prev.filter((m) => m.id !== messageId));
      }
    } catch (err) {
      console.error("Error deleting message:", err);
    }
    setContextMenu(null);
  };

  useEffect(() => {
    const closeContextMenu = () => setContextMenu(null);
    if (contextMenu) {
      document.addEventListener("click", closeContextMenu);
      return () => document.removeEventListener("click", closeContextMenu);
    }
  }, [contextMenu]);

  useEffect(() => {
    let cancelled = false;
    const revokeUrls = (items) => {
      (items || []).forEach((item) => {
        if (item?.url) URL.revokeObjectURL(item.url);
      });
    };

    if (!uploadFiles.length) {
      setUploadPreviews((prev) => {
        revokeUrls(prev);
        return [];
      });
      return;
    }

    (async () => {
      try {
        const next = await Promise.all(
          uploadFiles.map(async (file) => {
            try {
              return await buildAttachmentPreview(file);
            } catch {
              const fallbackName = String(file?.name || file?.fileName || "Файл");
              return { kind: "name", text: fallbackName, name: fallbackName };
            }
          })
        );
        if (cancelled) {
          revokeUrls(next);
          return;
        }
        setUploadPreviews((prev) => {
          revokeUrls(prev);
          return next;
        });
      } catch {
        if (!cancelled) {
          setUploadPreviews([]);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [uploadFiles]);

  useEffect(
    () => () => {
      uploadPreviews.forEach((item) => {
        if (item?.url) URL.revokeObjectURL(item.url);
      });
    },
    [uploadPreviews]
  );

  const openLocalFile = (file) => {
    const objectUrl = URL.createObjectURL(file);
    window.open(objectUrl, "_blank", "noopener,noreferrer");
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
    setFileActionModal(null);
  };

  const saveLocalFile = (file) => {
    const objectUrl = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = file?.name || "file";
    link.click();
    URL.revokeObjectURL(objectUrl);
    setFileActionModal(null);
  };

  const removeUploadFile = (removeIndex) => {
    setUploadFiles((prev) => prev.filter((_, idx) => idx !== removeIndex));
  };

  const handleKeyPress = (event) => {
    if (
      (event.code === "Enter" || event.code === "NumpadEnter") &&
      event.ctrlKey
    ) {
      let inp = document.getElementById("inputmessage");
      let cur_pos = 0;
      if (inp) cur_pos = inp.selectionStart || 0;
      if (inp)
        setMessage(
          inp.innerHTML.slice(0, cur_pos) + "\n" + inp.innerHTML.slice(cur_pos)
        );
      if (inp) inp.style.height = inp?.scrollHeight + "px";
    } else if (event.code === "Enter" || event.code === "NumpadEnter") {
      event.preventDefault();
      let btnsend = document.getElementById("btnsend");
      if (btnsend) btnsend.click();
    }
  };

  useEffect(() => {
    var elem = document.getElementById("inputmessage");

    if (elem) elem.addEventListener("keypress", handleKeyPress);

    return () => {
      if (elem) elem.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  useEffect(() => {
    setHandleScroll(1, tick);
  }, []);

  const isWav = (path) => (path ? path.endsWith(".wav") : false);
  const isImage = (path) =>
    path
      ? [".png", ".jpg", ".jpeg", ".bmp", ".gif", ".tiff"].some((ext) =>
          path.endsWith(ext)
        )
      : false;

  // const handleDownload = (path) => {
  //     window.open(`${url}/${path}`, '_blank');
  // };
  const handleDownload = async (path, filename) => {
    const response = await fetch(`${url}/${path}`);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = cleanFileName(path.split("/").pop()); // здесь задаем имя
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const handleSelectChatFromPicker = (user, chat) => {
    const enrichedChat = {
      ...chat,
      company_name: user?.company_name || null,
      company_id: user?.company_id || null,
    };
    const sameUser = Number(user?.user_id) === Number(userId);
    if (!sameUser) {
      pendingOpenChatRef.current = enrichedChat;
    }
    selectAccount(user);
    setActiveCompanyChat(enrichedChat);
    setChatListOpen(false);
  };

  const canCreateChatForUser = (user) =>
    !isEmployee && user?.access_mode !== "delegated";

  const handleStartCreateChat = (user) => {
    setCreateChatTargetUser(user);
    setNewChatTitle("");
    setShowCreateChatModal(true);
  };

  const handleCreateCompanyChat = async () => {
    const title = newChatTitle.trim();
    if (!title) {
      alert("Введите название чата");
      return;
    }
    const target = createChatTargetUser;
    if (!target?.user_id) {
      setShowCreateChatModal(false);
      return;
    }
    const companyId = Number(target.company_id) || 0;
    const companyLegacyId = Number(target.legacy_user_id) || 0;
    const companyBizId =
      Number(target.company_owner_user_id) || Number(target.business_user_id) || 0;
    const bizId =
      Number(businessAccountId) ||
      Number(userId) ||
      (companyBizId && companyBizId !== companyLegacyId ? companyBizId : 0) ||
      companyBizId;
    if (!companyId || !bizId) {
      alert("Не удалось создать чат: нет компании");
      return;
    }
    if (createChatBusy) return;
    setCreateChatBusy(true);
    try {
      const result = await createBusinessCompanyChat(bizId, companyId, title);
      if (!result?.success || !result.chat) {
        alert(result?.error || "Не удалось создать чат");
        return;
      }
      const created = mapApiChats([result.chat])[0];
      const key = String(target.user_id);
      const current = chatsByUserId[key] || [];
      const next = [...current, created];
      setChatsByUserId((prev) => ({ ...prev, [key]: next }));
      persistCompanyChats(target.user_id, next);
      setNewChatTitle("");
      setShowCreateChatModal(false);
      setCreateChatTargetUser(null);
    } catch (e) {
      console.error("[chat] create company chat", e);
      alert("Не удалось создать чат");
    } finally {
      setCreateChatBusy(false);
    }
  };

  const handlePickerMarkUnreadRequest = (user, pos) => {
    setPickerContextMenu({ user, x: pos.x, y: pos.y });
  };

  const confirmMarkUnreadForUser = async (target) => {
    if (!target?.user_id) return;
    const uid = Number(target.user_id);
    await applyMarkCompanyChatUnread({
      userId: uid,
      getCurrentBadge: (id) => pickerBadgeByUserId[id],
      patchChatBadge: (id, count) =>
        patchChatBadge(id, count, { companyId: Number(target.company_id) || 0, companyCount: count }),
      refreshAccountBadges,
    });
  };

  const handlePickerMarkUnreadConfirm = async () => {
    const target = pickerContextMenu?.user;
    setPickerContextMenu(null);
    await confirmMarkUnreadForUser(target);
  };

  const headingLongPressTimerRef = useRef(null);

  const clearHeadingLongPress = () => {
    if (headingLongPressTimerRef.current) {
      clearTimeout(headingLongPressTimerRef.current);
      headingLongPressTimerRef.current = null;
    }
  };

  const openSingleMarkUnreadMenu = (clientX, clientY) => {
    if (multiple) return;
    handlePickerMarkUnreadRequest(
      { user_id: userId, company_name: name },
      { x: clientX, y: clientY }
    );
  };

  const handleHeadingContextMenu = (e) => {
    if (multiple) return;
    e.preventDefault();
    e.stopPropagation();
    openSingleMarkUnreadMenu(e.clientX, e.clientY);
  };

  const handleHeadingTouchStart = (e) => {
    if (multiple) return;
    const touch = e.touches?.[0];
    if (!touch) return;
    clearHeadingLongPress();
    const { clientX, clientY } = touch;
    headingLongPressTimerRef.current = setTimeout(() => {
      openSingleMarkUnreadMenu(clientX, clientY);
    }, 500);
  };

  useEffect(() => {
    if (!pickerContextMenu) return undefined;
    const close = () => setPickerContextMenu(null);
    const timer = setTimeout(() => {
      document.addEventListener("click", close);
    }, 0);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", close);
    };
  }, [pickerContextMenu]);

  const escapeRegExp = (value) =>
    String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const getMessageSearchText = (msg) => {
    const fileName = msg?.path
      ? cleanFileName(String(msg.path).split("/").pop() || "")
      : "";
    return `${msg?.text || ""} ${fileName}`.toLowerCase();
  };

  const renderHighlightedText = (text) => {
    const src = String(text || "");
    const q = searchQuery.trim();
    if (!isSearchMode || !q) return src;
    const parts = src.split(new RegExp(`(${escapeRegExp(q)})`, "ig"));
    return parts.map((part, idx) =>
      part.toLowerCase() === q.toLowerCase() ? (
        <mark key={`${part}-${idx}`} className="chat_search_mark">
          {part}
        </mark>
      ) : (
        <React.Fragment key={`${part}-${idx}`}>{part}</React.Fragment>
      )
    );
  };

  useEffect(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!isSearchMode || !q) {
      setSearchMatchIndices([]);
      setActiveSearchMatchIdx(0);
      return;
    }
    const matches = [];
    chatMessages.forEach((msg, idx) => {
      if (getMessageSearchText(msg).includes(q)) matches.push(idx);
    });
    setSearchMatchIndices(matches);
    setActiveSearchMatchIdx(0);
  }, [chatMessages, isSearchMode, searchQuery]);

  const scrollToSearchMatch = (matchArrayIndex) => {
    const messageIndex = searchMatchIndices[matchArrayIndex];
    if (typeof messageIndex !== "number") return;
    const el = document.getElementById(`mess${messageIndex}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    if (!isSearchMode || searchMatchIndices.length === 0) return;
    scrollToSearchMatch(activeSearchMatchIdx);
  }, [activeSearchMatchIdx, isSearchMode, searchMatchIndices]);

  const jumpSearchMatch = (direction) => {
    if (!searchMatchIndices.length) return;
    setActiveSearchMatchIdx((prev) => {
      if (direction === "prev") {
        return prev <= 0 ? searchMatchIndices.length - 1 : prev - 1;
      }
      return prev >= searchMatchIndices.length - 1 ? 0 : prev + 1;
    });
  };

  const enterSearchMode = () => setIsSearchMode(true);
  const exitSearchMode = () => {
    setIsSearchMode(false);
    setSearchQuery("");
    setSearchMatchIndices([]);
    setActiveSearchMatchIdx(0);
  };

  const handleChatNavBack = () => {
    setActiveCompanyChat(null);
    setChatListOpen(true);
    setPickerOpen(true);
  };

  useEffect(() => {
    if (!pickerOpen && !chatListOpen) {
      document.body.classList.remove("chat-company-picker-open");
      return undefined;
    }

    document.body.classList.add("chat-company-picker-open");
    return () => document.body.classList.remove("chat-company-picker-open");
  }, [pickerOpen, chatListOpen]);

  const showMessages = !pickerOpen && !chatListOpen && !!activeCompanyChat;
  const pagePickerOpen = pickerOpen || chatListOpen;

  return (
    <div className={`main_cntr_chat section-page chat-page${pagePickerOpen ? " section-page--picker-open" : ""}`}>
      <div
        className={`section-page-heading manrope-bold color_white${!multiple ? " section-page-heading--mark-unread" : ""}`}
        onContextMenu={!multiple ? handleHeadingContextMenu : undefined}
        onTouchStart={!multiple ? handleHeadingTouchStart : undefined}
        onTouchEnd={!multiple ? clearHeadingLongPress : undefined}
        onTouchMove={!multiple ? clearHeadingLongPress : undefined}
        onTouchCancel={!multiple ? clearHeadingLongPress : undefined}
        title={!multiple ? "Удержите или ПКМ — сделать непрочитанным" : undefined}
      >
        Чат
      </div>
      {showMessages && (
      <div className="chat_page_header section-page_title_cntr">
          <button
            type="button"
            className="page-header-nav-back"
            onClick={handleChatNavBack}
          aria-label="К списку компаний"
          >
            {arrowLIcon}
          </button>
        <div className="chat_page_header_titles">
          {(activeCompanyChat?.company_name || name) && (
            <div className="chat_page_company_name manrope-bold color_white section-company-title">
              {activeCompanyChat?.company_name || name}
            </div>
          )}
          <div className="chat_page_chat_title color_white">
            {activeCompanyChat?.title || "Чат"}
          </div>
        </div>
        {isSearchMode ? (
          <div className="chat_search_icon_btn chat_search_active section-page_actions">
            <input
              className="chat_search_input"
              placeholder="Поиск в чате"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
            <button
              type="button"
              className="chat_search_nav_btn"
              onClick={() => jumpSearchMatch("prev")}
              disabled={searchMatchIndices.length === 0}
              aria-label="Предыдущее совпадение"
            >
              &#9650;
            </button>
            <button
              type="button"
              className="chat_search_nav_btn"
              onClick={() => jumpSearchMatch("next")}
              disabled={searchMatchIndices.length === 0}
              aria-label="Следующее совпадение"
            >
              &#9660;
            </button>
            <button
              type="button"
              className="chat_search_nav_btn"
              onClick={exitSearchMode}
              aria-label="Закрыть поиск"
            >
              &#10005;
            </button>
          </div>
        ) : (
          <button
            type="button"
            className="chat_search_icon_btn section-page_actions"
            aria-label="Поиск"
            onClick={enterSearchMode}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M11 4a7 7 0 1 0 4.4 12.44l3.58 3.58a1 1 0 0 0 1.42-1.42l-3.58-3.58A7 7 0 0 0 11 4Zm0 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z" fill="#FFFFFF" />
            </svg>
          </button>
        )}
      </div>
      )}

      {pickerOpen ? (
        <div className="tasks_subcntr section-page-picker">
          {accessLoading ? (
            <div className="manrope-bold" style={{ padding: "40px 16px", textAlign: "center", color: "#64748b" }}>
              Загрузка…
            </div>
          ) : accessLoadError ? (
            <div className="manrope-bold" style={{ padding: "40px 16px", textAlign: "center", color: "#64748b" }}>
              {accessLoadError}
            </div>
          ) : noAccess ? (
            <div className="manrope-bold" style={{ padding: "40px 16px", textAlign: "center", color: "#64748b" }}>
              Нет доступных чатов
            </div>
          ) : (
          <CompanyPickerList
              users={pickerUsers}
              itemClickable={false}
              hideArrow
              badgeByUserId={null}
              onMarkUnread={!isEmployee && multiple ? handlePickerMarkUnreadRequest : null}
              renderItemTrailing={(user) =>
                canCreateChatForUser(user) ? (
                  <button
                    type="button"
                    className="company-picker-chat-add"
                    aria-label={`Создать чат для ${user.company_name}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleStartCreateChat(user);
                    }}
                  >
                    +
                  </button>
                ) : null
              }
              renderItemExtra={(user) => {
                const chats = chatsByUserId[String(user.user_id)];
                if (chats === undefined) {
                  return (
                    <div className="company-picker-chats">
                      <div className="company-picker-chats-empty">Загрузка…</div>
                    </div>
                  );
                }
                if (!chats.length) {
                  return (
                    <div className="company-picker-chats">
                      <div className="company-picker-chats-empty">Нет чатов</div>
                    </div>
                  );
                }
                return (
                  <div className="company-picker-chats">
                    {chats.map((chat) => {
                      const chatKey = Number(chat.id) || 0;
                      const live = chatKey ? chatByChatId?.[chatKey] : null;
                      const unread = Number(live ?? chat.unread) || 0;
                      const badge = formatBadgeCount(unread);
                      return (
                        <button
                          key={chat.id}
                          type="button"
                          className="company-picker-chat-row"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectChatFromPicker(user, chat);
                          }}
                        >
                          <span className="company-picker-chat-title">{chat.title}</span>
                          <span className="company-picker-trailing">
                            {badge && (
                              <span className="company-picker-badge">{badge}</span>
                            )}
                            {arrowRIcon}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                );
              }}
            />
          )}
          {showCreateChatModal && !isEmployee && (
            <div className="modal-container">
              <div className="modal-content">
                <div
                  className="close-button"
                  onClick={() => {
                    setShowCreateChatModal(false);
                    setCreateChatTargetUser(null);
                  }}
                >
                  {closeIconTask}
                </div>
                <div style={{ textAlign: "center" }} className="manrope-bold color_blue_1 fs-20">
                  Новый чат
                </div>
                <div style={{ width: "100%", marginTop: "25px" }}>
                  <div className="manrope-bold" style={{ fontSize: "16px", textAlign: "left" }}>
                    Название
                  </div>
                </div>
                <input
                  className="input_task manrope-bold"
                  placeholder="Название чата"
                  value={newChatTitle}
                  onChange={(e) => setNewChatTitle(e.target.value)}
                />
                <div style={{ textAlign: "center", marginTop: "16px" }}>
                  <button
                    type="button"
                    className="create-button manrope-bold"
                    onClick={handleCreateCompanyChat}
                    disabled={createChatBusy}
                  >
                    {createChatBusy ? "СОЗДАНИЕ…" : "СОЗДАТЬ"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
      <div className="cntr_messages">
        <div onClick={scrollToBottom} className="arrow_down_scroll">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25px"
            height="25px"
            viewBox="0 0 1024 1024"
            version="1.1"
          >
            <path
              d="M903.232 256l56.768 50.432L512 768 64 306.432 120.768 256 512 659.072z"
              fill="#000000"
            />
          </svg>
        </div>

        <div id="messages" className="messages">
          {messagesLoading ? (
            <div className="load_msg">
              {connectionStatus || "Загрузка"}
            </div>
          ) : connectionStatus ? (
            <div className="load_msg">{connectionStatus}</div>
          ) : (
            <div>
              {/* {chatMessages.slice(startIndexMsg, endIndexMsg + 1).map((message, index) => ( */}
              {chatMessages.map((message, index) => {
                const senderType = String(message.sender_type || "").trim();
                const fromAccountType = String(
                  message.from_account_type || ""
                ).trim();
                const fromId = Number(message.from_id) || 0;
                const accountantId =
                  Number(currentUser?.accountant_id || acc_id) || 0;
                const bossIds = [
                  currentUser?.company_owner_user_id,
                  currentUser?.business_user_id,
                  currentUser?.legacy_user_id,
                ]
                  .map((v) => Number(v) || 0)
                  .filter((v) => v > 0);

                const isFromEmployee =
                  fromAccountType === "employee" ||
                  senderType === "сотрудник";
                const isFromClientMeta =
                  fromAccountType === "business" ||
                  senderType === "клиент";
                const isFromBoss =
                  isFromClientMeta || bossIds.includes(fromId);
                // from_account_type важнее кривого sender_type в старых строках.
                // sender_type='бух' без accountant meta и без from_id=acc — не бухгалтер
                // (так ошибочно сохранялись сообщения сотрудников).
                const isFromAccountant =
                  !isFromEmployee &&
                  !isFromClientMeta &&
                  ((accountantId > 0 && fromId === accountantId) ||
                    (senderType === "бух" &&
                      (!!String(message.accountant_name || "").trim() ||
                        !!message.accountant_photo_path ||
                        (accountantId > 0 &&
                          Number(message.sender_id) === accountantId))));

                // В вебе всё, что не бухгалтер — справа (босс + сотрудники)
                const isClientSide = !isFromAccountant;

                const showFromAccountant = isFromAccountant;
                const showFromEmployee =
                  isClientSide && (isFromEmployee || !isFromBoss);
                const showFromLeader = isClientSide && isFromBoss;
                const showSenderHeader =
                  showFromAccountant || showFromEmployee || showFromLeader;

                const senderLabel = showFromAccountant
                  ? (message.accountant_name &&
                    String(message.accountant_name).trim()) ||
                    (message.from_name && String(message.from_name).trim()) ||
                    ""
                  : showFromLeader
                    ? (accountOwnerAvatar.name &&
                      String(accountOwnerAvatar.name).trim()) ||
                      (message.from_name &&
                        String(message.from_name).trim()) ||
                      ""
                    : (message.from_name && String(message.from_name).trim()) ||
                      "";
                const accPath =
                  showFromAccountant && message.accountant_photo_path
                  ? String(message.accountant_photo_path).replace(/^\/+/, "")
                  : "";
                const accUri = accPath ? `${url}/${accPath}` : null;
                // Сообщения компаний: аватар/имя из профиля владельца аккаунта
                const headerAvatarUri = showFromAccountant
                  ? accUri
                  : accountOwnerAvatar.uri;
                const senderInitial = showFromAccountant
                  ? "Б"
                  : accountOwnerAvatar.initial || (showFromEmployee ? "С" : "Р");
                const senderFallback = showFromAccountant
                  ? "Бухгалтер"
                  : showFromEmployee
                    ? "Сотрудник"
                    : "Руководитель";

                return (
                <div
                  onDoubleClick={() => handleDoubleClick(index)}
                  onContextMenu={(e) => handleMessageContextMenu(e, message)}
                  id={"mess" + index}
                  key={index}
                  className="row_message"
                  style={{
                    justifyContent: isClientSide ? "right" : "left",
                    alignItems: "flex-end",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: isClientSide ? "flex-end" : "flex-start",
                      minWidth: 0,
                    }}
                  >
                    <div
                      className={
                        isClientSide
                          ? "cntr_message_item_my"
                          : "cntr_message_item"
                      }
                      style={
                        showSenderHeader
                          ? { maxWidth: "48%", marginLeft: 0 }
                          : {}
                      }
                    >
                    {showSenderHeader && (
                      <div
                        className={
                          isClientSide
                            ? "chat_msg_sender_header chat_msg_sender_header--company"
                            : "chat_msg_sender_header chat_msg_sender_header--accountant"
                        }
                      >
                        {showFromAccountant && (
                          headerAvatarUri ? (
                            <img
                              src={headerAvatarUri}
                              alt=""
                              className="chat_msg_sender_avatar"
                            />
                          ) : (
                            <div className="chat_msg_sender_avatar chat_msg_sender_avatar--initials">
                              {senderInitial}
                            </div>
                          )
                        )}
                        <span className="user_name" style={{ maxWidth: 220 }}>
                          {senderLabel || senderFallback}
                        </span>
                        {isClientSide && (
                          headerAvatarUri ? (
                            <img
                              src={headerAvatarUri}
                              alt=""
                              className="chat_msg_sender_avatar"
                            />
                          ) : (
                            <div className="chat_msg_sender_avatar chat_msg_sender_avatar--initials">
                              {senderInitial}
                            </div>
                          )
                        )}
                      </div>
                    )}
                    {/* {message.qm_id &&
                                            <div className='cntr_quoted_message' onClick={() => handleClickQuotedMessage(message.qm_id)}>
                                                <label className='user_name'>{message.qm_user_name}</label>
                                                <div className='message_text'>{message.qm_text}</div>
                                            </div>
                                        } */}
                    {/* <label className='user_name'>{message.user_name}</label> */}
                    <div>
                      {/* {message.path ?
                                                (message.path.slice(message.path.lastIndexOf('.')) === '.jpeg' || message.path.slice(message.text.lastIndexOf('.')) === '.jpg' || message.text.slice(message.text.lastIndexOf('.')) === '.png' ?
                                                    <img style={{ width: '90%' }} src={(message.user_id === 2 || message.user_id === 12 ? `${url}/static/uploads/` : 'http://5.63.153.239:443/static/uploads/') + message.text} alt='' /> :
                                                    message.text.slice(message.text.lastIndexOf('.')) === '.mp4' ?
                                                        <video style={{ width: '90%' }} controls={true}>
                                                            <source src={(message.user_id === 2 || message.user_id === 12 ? `${url}/static/uploads/` : 'http://5.63.153.239:443/static/uploads/') + message.text} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
                                                        </video> :
                                                        <a rel='noreferrer' download href={(message.user_id === 2 || message.user_id === 12 ? `${url}/static/uploads/` : 'http://5.63.153.239:443/static/uploads/') + message.text} target='_blank'>{message.text}</a>
                                                ) :
                                                <div className='message_text'>{message.text}</div>
                                            } */}
                      {isImage(message.path) && (
                        <img
                          style={{ width: "90%" }}
                          src={`${url}/${message.path}`}
                          alt=""
                        />
                      )}
                      {isWav(message.path) && (
                        <audio
                          style={{ width: "100%" }}
                          src={`${url}/${message.path}`}
                          controls
                        />
                      )}
                      {message.path && (
                        // <div onClick={() => handleDownload(message.path)}>Скачать</div>
                        <div
                          onClick={() => handleDownload(message.path)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={file_img}
                            alt="Файл"
                            style={{ width: "32px", height: "32px" }}
                          />
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span
                              style={{ fontSize: "12px", fontWeight: "400" }}
                            >
                              {cleanFileName(message.path.split("/").pop())}
                            </span>
                            <span style={{ fontSize: "12px", color: "#666" }}>
                              {formatSize(message.size)}
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="message_text">{renderHighlightedText(message.text)}</div>
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span
                        className="datetime manrope-400 color_grey"
                        style={{ fontSize: "12px" }}
                      >
                        {formatMessageSentLine(message.datetime, message.edited_at)}
                      </span>
                      {parseInt(message.from_id) === parseInt(userId) && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {!message.is_viewed
                            ? singleCheck("#696868ff", 16)
                            : message.view_status === "viewed"
                            ? doubleCheck("#3B82F6", 18)
                            : doubleCheck("#696868ff", 18)}
                        </div>
                      )}
                    </div>
                    </div>
                  </div>
                </div>
                );
              })}
            </div>
          )}
        </div>

        {contextMenu && (
          <div
            className="chat-context-menu"
            style={{
              position: "fixed",
              left: contextMenu.x,
              top: contextMenu.y,
              zIndex: 10000,
              backgroundColor: "white",
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
              padding: "4px 0",
              minWidth: "180px",
            }}
          >
            <div
              style={{
                padding: "10px 16px",
                cursor: "pointer",
                fontSize: "14px",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              onClick={async () => {
                const txt = String(contextMenu.message?.text || "").trim();
                if (txt) {
                  try {
                    await navigator.clipboard.writeText(txt);
                  } catch (e) {
                    console.warn("clipboard write failed", e);
                  }
                }
                setContextMenu(null);
              }}
            >
              Копировать
            </div>
            <div
              style={{
                padding: "10px 16px",
                cursor: "pointer",
                fontSize: "14px",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              onClick={() => {
                if (contextMenu.message?.text != null) {
                  setEditModal({
                    messageId: contextMenu.message.id,
                    text: contextMenu.message.text,
                  });
                }
                setContextMenu(null);
              }}
            >
              Редактировать
            </div>
            <div
              style={{
                padding: "10px 16px",
                cursor: "pointer",
                fontSize: "14px",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              onClick={() => {
                handleDeleteMessage(contextMenu.message.id);
              }}
            >
              Удалить
            </div>
          </div>
        )}

        {editModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10001,
            }}
            onClick={() => setEditModal(null)}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "20px",
                width: "90%",
                maxWidth: "400px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ marginBottom: "12px", fontWeight: "600" }}>
                Редактирование сообщения
              </div>
              <textarea
                value={editModal.text}
                onChange={(e) =>
                  setEditModal((prev) => ({ ...prev, text: e.target.value }))
                }
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                  boxSizing: "border-box",
                }}
                placeholder="Текст сообщения"
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px",
                  marginTop: "16px",
                }}
              >
                <button
                  onClick={() => setEditModal(null)}
                  style={{
                    padding: "8px 16px",
                    background: "none",
                    border: "none",
                    color: "#666",
                    cursor: "pointer",
                  }}
                >
                  Отмена
                </button>
                <button
                  onClick={() =>
                    handleEditMessage(editModal.messageId, editModal.text?.trim())
                  }
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#3262FF",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Сохранить
                </button>
              </div>
            </div>
          </div>
        )}

        {qoutedMessageIndex !== 0 && (
          <div className="quoted_msg_input">
            <svg
              onClick={() => setQoutedMessageIndex(0)}
              className="close_svg"
              xmlns="http://www.w3.org/2000/svg"
              width="30px"
              height="30px"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9393 12L6.9696 15.9697L8.03026 17.0304L12 13.0607L15.9697 17.0304L17.0304 15.9697L13.0607 12L17.0303 8.03039L15.9696 6.96973L12 10.9393L8.03038 6.96973L6.96972 8.03039L10.9393 12Z"
                fill="#080341"
              />
            </svg>
            <div className="cntr_quoted_message">
              <label className="user_name">
                {chatMessages[qoutedMessageIndex].user_name}
              </label>
              <div className="message_text">
                {chatMessages[qoutedMessageIndex].text}
              </div>
            </div>
          </div>
        )}

        {uploadFiles.length > 0 && (
          <div
            style={{
              width: "100%",
              marginBottom: "8px",
              padding: "8px",
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              fontSize: "12px",
              maxHeight: "320px",
              overflow: "auto",
              boxSizing: "border-box",
              border: "1px solid #dbe1f5",
            }}
          >
              {uploadFiles.map((file, index) => {
                const p = uploadPreviews[index];
                const rawName = String(file?.name || file?.fileName || "Файл");
                const shortName =
                  rawName.length > 40 ? `${rawName.slice(0, 40)}...` : rawName;
                return (
                  <div
                    key={`${rawName}-${index}`}
                    onClick={() => setFileActionModal(file)}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      marginBottom: "8px",
                      cursor: "pointer",
                      backgroundColor: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      padding: "6px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeUploadFile(index);
                      }}
                      style={{
                        border: "none",
                        background: "#ef4444",
                        color: "#fff",
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontSize: "12px",
                        lineHeight: "18px",
                        padding: 0,
                        flexShrink: 0,
                      }}
                      aria-label="Удалить файл"
                      title="Удалить файл"
                    >
                      ×
                    </button>
                    {p?.kind === "image" && p?.url ? (
                      <img
                        src={p.url}
                        alt=""
                        style={{ width: "36px", height: "36px", borderRadius: "6px", objectFit: "cover" }}
                      />
                    ) : (
                      <img src={file_img} alt="" style={{ width: "24px", height: "24px" }} />
                    )}
                    <div style={{ minWidth: 0 }}>
                      <div style={{ color: "#111827", wordBreak: "break-word" }}>{shortName}</div>
                      {p?.kind === "pdf" && p?.url && (
                        <iframe
                          title={`pdf-preview-${index}`}
                          src={p.url}
                          style={{
                            marginTop: "6px",
                            width: "220px",
                            height: "140px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            backgroundColor: "#fff",
                          }}
                        />
                      )}
                      {p?.kind === "text" && (
                        <div
                          style={{
                            color: "#6b7280",
                            marginTop: "4px",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                          }}
                        >
                          {(p.text || "").slice(0, 160)}
                          {(p.text || "").length > 160 ? "..." : ""}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        )}
        <SuspendHoverHint suspended={isServiceSuspended} className="suspend-hover-hint--composer">
        <div
          className={`cntr_input_message${isServiceSuspended ? ' cntr_input_message--suspended' : ''}`}
        >
          <textarea
            id="inputmessage"
            className={`input_message nores${isServiceSuspended ? ' input_message--suspended' : ''}`}
            value={message}
            placeholder="Сообщение..."
            readOnly={isServiceSuspended}
            onChange={(e) => {
              if (!isServiceSuspended) setMessage(e.target.value);
            }}
          />
          <div className="cntr_input_btns">
            <div
              className={`file_upload${isServiceSuspended ? ' file_upload--suspended' : ''}`}
            >
              <label htmlFor="myfile" style={{ cursor: isServiceSuspended ? 'not-allowed' : 'pointer' }}>
                {fileSelect}
              </label>
              {uploadFiles.length > 0 && (
                <span style={{ fontSize: 12, color: "#3262FF", marginLeft: 6 }}>
                  {uploadFiles.length}
                </span>
              )}
              <input
                id="myfile"
                type="file"
                name="files[]"
                multiple
                disabled={isServiceSuspended}
                onChange={(e) => {
                  if (isServiceSuspended) return;
                  const pickedFiles = Array.from(e.target.files || []).filter(Boolean);
                  if (pickedFiles.length > 0) {
                    setUploadFiles((prev) => [...prev, ...pickedFiles]);
                  }
                  e.target.value = "";
                }}
              />
            </div>

            {isServiceSuspended || message !== "" || uploadFiles.length > 0 ? (
              <div
                style={{ width: "40px" }}
                className={`btn_send${isServiceSuspended ? ' btn_send--suspended' : ''}`}
                id="btnsend"
                onClick={isServiceSuspended ? undefined : handleClickSendMessage}
                role="button"
                aria-disabled={isServiceSuspended}
              >
                {sendIcon}
              </div>
            ) : (
              <div style={{ width: "40px", flexShrink: 0 }} aria-hidden />
            )}
          </div>
        </div>
        </SuspendHoverHint>
        {fileActionModal && (
          <div
            className="file-action-overlay"
            role="presentation"
            onClick={() => setFileActionModal(null)}
          >
            <div
              className="file-action-card"
              role="dialog"
              aria-modal="true"
              onClick={(e) => e.stopPropagation()}
            >
              <p className="file-action-title manrope-bold">
                {fileActionModal.name || "Файл"}
              </p>
              <div className="file-action-buttons">
                <button
                  type="button"
                  className="file-action-btn file-action-btn-open manrope-bold"
                  onClick={() => openLocalFile(fileActionModal)}
                >
                  Открыть
                </button>
                <button
                  type="button"
                  className="file-action-btn file-action-btn-save manrope-bold"
                  onClick={() => saveLocalFile(fileActionModal)}
                >
                  Сохранить
                </button>
                <button
                  type="button"
                  className="file-action-btn file-action-btn-cancel manrope-bold"
                  onClick={() => setFileActionModal(null)}
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      )}
      {pickerContextMenu && (
        <div
          className="company-picker-context-menu"
          style={{ left: pickerContextMenu.x, top: pickerContextMenu.y }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="company-picker-context-menu-item"
            onClick={handlePickerMarkUnreadConfirm}
          >
            Сделать непрочитанным
          </button>
        </div>
      )}
    </div>
  );
}

export default Chat;
